import React from 'react';
import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import { SeparatorQCFieldBoxStyle, SeparatorQCFieldTypoStyle } from './styles';
import { SeparatorQcFieldName } from './const';
import { ValueFieldsTypesProps } from '50.quickConnect.Fields/FieldsTypes/types';

const SeparatorQcField = ({ field, labelSpan }: ValueFieldsTypesProps) => {
  const { id, label } = field;
  const nameWithId = `${SeparatorQcFieldName}-${id}`;

  return label ? (
    <>
      <Box data-cy={nameWithId} sx={SeparatorQCFieldBoxStyle}>
        <Typography component="span" sx={SeparatorQCFieldTypoStyle}>
          {labelSpan}
        </Typography>
      </Box>
    </>
  ) : (
    <Box data-cy={nameWithId} sx={SeparatorQCFieldBoxStyle}></Box>
  );
};
export default observer(SeparatorQcField);
